import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";

import {
  Label,
  Input,
  InputGroup,
  InputGroupText,
  Table,
  FormGroup,
} from "reactstrap";

import PaginatedItems from "../../components/PaginatedItems";
import { editStatus, membersDetails } from "../../http/http-calls";
import moment from "moment";
import { convertUrlToCdn } from "../../helper-methods";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { copyToClipBoard, deepClone, showToast } from "../../helper-methods";
import { Oval } from "react-loader-spinner";

const MembersPage = () => {
  const navigate = useNavigate();

  //state
  const [isEmbeddedLoading, setIsEmbeddedLoading] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  // const [checked, setChecked] = useState(false);
  const [users, setUsers] = useState([]);
  const [count, setCount] = useState("");
  const [itemPerPage, setItemPerPage] = useState("");
  const [payload, setPayload] = useState({
    pageNumber: 1,
    pageSize: 10,
  });
  const [flag, setFlag] = useState(false); // for button disabled after one click

  //see all members
  const _fetchAllMembers = async (pageConfig = payload) => {
    if (pageConfig && pageConfig.isFetchAll) {
      try {
        const res = await membersDetails(pageConfig);
        // console.log("CSV>>", res);
        setUsers(res.data);
        setCount(res.usersCount);
        setItemPerPage(res.data.length);
      } catch (error) {
        // console.log(error);
      }
    } else {
      // Only show embedded loader for filtering/pagination, not initial load
      if (!pageConfig?.isInitialLoad && !isInitialLoad) {
        setIsEmbeddedLoading(true);
      }

      try {
        const res = await membersDetails(pageConfig || payload);
        // console.log("allMember>>", res);
        setUsers(res.data);
        setCount(res.usersCount);
        setItemPerPage(res.data.length);
        if (!pageConfig?.isInitialLoad && !isInitialLoad) {
          setIsEmbeddedLoading(false);
        }
        if (isInitialLoad || pageConfig?.isInitialLoad) setIsInitialLoad(false);
      } catch (error) {
        // console.log(error);
        if (!pageConfig?.isInitialLoad && !isInitialLoad) {
          setIsEmbeddedLoading(false);
        }
        if (isInitialLoad || pageConfig?.isInitialLoad) setIsInitialLoad(false);
      }
    }
  };
  /* eslint-disable */
  useEffect(() => {
    _fetchAllMembers({ ...payload, isInitialLoad: true });
  }, []);

  //status change
  const _changeStatus = async (event, id, index) => {
    setFlag(true);

    let oldReports = JSON.parse(JSON.stringify(users));

    const value = event.target.value;
    // console.log("value",value);
    users[index].isActive = value;
    setUsers([...users]);

    try {
      const res = await editStatus(id, { status: value });
      // console.log("searchFilter>>", res);
      copyToClipBoard("status", event.target.value);
    } catch (error) {
      setUsers(oldReports);
      // console.log(error);
    }
    setFlag(false);
  };

  //change create group status
  const _changeCreateGroupStatus = async (event, id, index) => {
    setFlag(true);

    let oldReports = JSON.parse(JSON.stringify(users));

    const value = event.target.checked;
    // console.log(">>", value);
    // console.log("value", value);
    users[index].isAllowToCreateGroup = value;
    setUsers([...users]);

    try {
      const res = await editStatus(id, { isAllowToCreateGroup: value });
      // console.log("searchFilter>>", res);
      copyToClipBoard("status", event.target.value);
    } catch (error) {
      setUsers(oldReports);
      // console.log(error);
      showToast(error?.reason, "error");
    }
    setFlag(false);
  };

  // debounce function
  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 500);
    };
  };

  //filter and search
  const _statusHandler = async (field, event) => {
    const newSearchData = payload;
    newSearchData[field] = event.target.value;
    // setSearchData(newSearchData);

    if (event.target.value.length) {
      newSearchData[field] = event.target.value;
      setPayload({ ...payload, pageNumber: 1 });
    } else {
      // console.log("field >>", field);
      delete newSearchData[field];
    }
    // setSearchData(newSearchData);
    // console.log("newSearchFilterData >", newSearchData);
    _checkHandler(newSearchData);
  };

  //debouncing function use
  const optimizedFn = useCallback(debounce(_statusHandler));

  //api call for search and filter
  const _checkHandler = async (data) => {
    // console.log("check>>", data);
    await _fetchAllMembers(data);
  };

  //pagination
  const handlePageClick = (pageNumber) => {
    console.log(pageNumber);
    let newPageConfig = deepClone(payload);
    newPageConfig["pageNumber"] = pageNumber + 1;
    setPayload(newPageConfig);
    _fetchAllMembers(newPageConfig);
  };

  return (
    <>
      <div className="innerHeader">
        {/* page title */}
        <h2>Members</h2>
      </div>

      {/* filter */}
      <div className="filterWrapper">
        <div className="filterIcon">
          <i className="fas fa-filter"></i>
        </div>

        <div className="filterForm">
          <div className="formGroup">
            <Label>Groups Created</Label>
            <Input
              type="select"
              onChange={(event) => optimizedFn("myGroupCount", event)}
            >
              <option value="">All</option>
              <option value="0">0</option>
              <option value="1">1</option>
              <option value="2">2</option>
            </Input>
          </div>

          <div className="formGroup">
            <Label>Groups Joined</Label>
            <Input
              type="select"
              onChange={(event) => optimizedFn("joinGroupCount", event)}
            >
              <option value="">All</option>
              <option value="0-1">1</option>
              <option value="2-5">2-5</option>
              <option value="6-10">6-10</option>
              <option value="11-25">11-25</option>
              <option value="25-50">25-50</option>
              <option value="51">50+</option>
            </Input>
          </div>

          <div className="formGroup">
            <Label>Member Since</Label>
            <Input
              type="select"
              onChange={(event) => optimizedFn("memberSince", event)}
            >
              <option value="">All</option>
              <option value="Today">Today</option>
              <option value="This week">This Week</option>
              <option value="This month">This Month</option>
              <option value="This year">This Year</option>
            </Input>
          </div>

          <div className="formGroup">
            <Label>Status</Label>
            <Input
              type="select"
              onChange={(event) => optimizedFn("status", event)}
            >
              <option value="">All</option>
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </Input>
          </div>

          {/* search */}
          <div className="formGroup searchbar">
            <Label>Search</Label>
            <InputGroup>
              <Input
                placeholder="Search..."
                onChange={(event) => optimizedFn("searchText", event)}
              />
              <InputGroupText>
                <i className="fas fa-search"></i>
              </InputGroupText>
            </InputGroup>
          </div>
        </div>
      </div>

      <React.Fragment>
        <div className="bg-white p-2 mt-3" style={{ borderRadius: 8 }}>
          {isEmbeddedLoading ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                margin: "40px 0",
                minHeight: "200px",
                alignItems: "center",
              }}
            >
              <Oval color="#3498DB" />
            </div>
          ) : (
            <Table responsive>
              <thead>
                <tr>
                  {/* <th className='checkColumn'>
                <FormGroup check>
                  <Input id='checkbox2' type='checkbox' />
                </FormGroup> 
              </th> */}
                  <th>Member</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Groups Created</th>
                  <th>Joined</th>
                  <th>Signed</th>
                  <th className="text-center">Allow To Create Group</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>
                {users.map((member, index) => (
                  <tr key={index}>
                    {/* <td>
                  <FormGroup check>
                    <Input
                      id='checkbox2'
                      type='checkbox'
                      defaultChecked={checked}
                      onChange={() => setChecked(!checked)}
                    /> 
                  </FormGroup>
                </td> */}
                    <td>
                      <div
                        className="userInfo tableLink"
                        onClick={() => navigate(`/members-view/${member._id}`)}
                      >
                        <img
                          src={
                            member.displaypictureurl
                              ? convertUrlToCdn(member.displaypictureurl)
                              : require("../../assets/img/default-profile.svg")
                                  .default
                          }
                          alt="user"
                          className="object-cover w-full h-full"
                        />
                        {member.fullname}
                      </div>
                    </td>
                    <td onClick={() => copyToClipBoard("copy", member.email)}>
                      {member.email}
                    </td>
                    <td onClick={() => copyToClipBoard("copy", member.phone)}>
                      {member.phone}
                    </td>
                    <td>
                      <Link to="">{member._myGrouped?.length}</Link>
                    </td>
                    <td>
                      <Link to="">{member._joinGrouped?.length}</Link>
                    </td>

                    <td>{moment(member.createdAt).format("Do MMM")}</td>
                    <td className="text-center">
                      {/* <div > */}
                      <FormGroup switch>
                        <Input
                          type="checkbox"
                          checked={member?.isAllowToCreateGroup}
                          onChange={(event) =>
                            _changeCreateGroupStatus(event, member._id, index)
                          }
                          disabled={flag === true}
                          style={{ float: "unset" }}
                        />
                      </FormGroup>
                      {/* </div> */}
                    </td>
                    <td>
                      <div className="action">
                        <Input
                          type="select"
                          value={member.isActive}
                          disabled={flag === true}
                          onChange={(event) =>
                            _changeStatus(event, member._id, index)
                          }
                        >
                          <option value="true">Active</option>
                          <option value="false">Inactive</option>
                        </Input>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </div>
      </React.Fragment>

      <ToastContainer
        position="bottom-right"
        autoClose={1000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      {/* pagination */}
      <PaginatedItems
        itemsPerPages={itemPerPage}
        totalCount={count}
        selectedPage={payload.pageNumber}
        itemsPerPage={payload.pageSize}
        onPageChange={handlePageClick}
      />
    </>
  );
};

export default MembersPage;
